export default {
    deleteSchedules:    { method: 'delete', url: 'class_schedules/{id}'},
    postSchedules:      { method: 'post', url: 'class_schedules'},
    getSchedules:       { method: 'get', url: 'class_schedules'},
    postDynamicGenerate:       { method: 'post', url: 'dynamic_times/generate/groups'},
    postDates:       { method: 'post', url: 'class-schedules/dates'},
    deleteSchedulesByGrid: { method: 'delete', url: 'class-schedules/grid/{id}'},
    deleteSchedulesByGroup: { method: 'delete', url: 'class-schedules/group/{id}'},
    getResolvedFeatures: { method: 'get', url: 'role-features/resolved?context=schedule'},
}
